import { Actualizacion1 } from "../assets";
import styles, { layout } from "../style";
import { specifications } from "../constants";

import { motion } from "framer-motion";

const Specifications = () => (
    <section id="specifications" className={`${layout.sectionReverse} items-center justify-between gap-16 overflow-hidden scroll-mt-24`}>
        <motion.div 
            initial={{ x: -100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="flex-1 flex justify-center items-center relative"
        >
            <div className="relative overflow-hidden rounded-3xl border border-slate-100 bg-white shadow-xl group w-full max-w-[800px]">
                <img 
                    src={Actualizacion1} 
                    alt="Specifications" 
                    className="w-full h-auto object-contain transition-transform duration-1000 group-hover:scale-[1.02]"
                />
            </div>
        </motion.div>

        <motion.div 
            initial={{ x: 100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className={`${layout.sectionInfo} flex-1`}
        >
            <h2 className={`${styles.heading2} mb-12`}>
                Ficha Técnica
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6 w-full">
                {specifications.map((specification, index) => (
                    <motion.div 
                        key={specification.id}
                        initial={{ opacity: 0, y: 15 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.3 + index * 0.1 }}
                        className="flex flex-col p-5 rounded-2xl bg-white hover:bg-slate-50 transition-all border border-slate-50 hover:border-slate-100 group shadow-sm hover:shadow-md h-full"
                    >
                        <span className="text-secondary text-[16px] font-bold tracking-widest mb-2 group-hover:text-accent transition-colors uppercase">
                            {specification.title}
                        </span>
                        <p className={`${styles.paragraph} text-[14px] leading-relaxed text-slate-500`}>
                            {specification.content}
                        </p>
                    </motion.div>
                ))}
            </div>
        </motion.div>
    </section>
);

export default Specifications;